export enum ValueControlDataTypes {
    String = "String",
    Integer = "Integer",
    Long = "Long",
    Double = "Double",
    Boolean = "Boolean",
    HTriState = "HTriState",
    HDate = "HDate",
    HTags = "HTags",
    HTime = "HTime",
    HHour = "HHour",
    HHourInterval = "HHourInterval",
    HHourIntervals = "HHourIntervals",
    Object = "Object",
    Color = "Color",
    Enum = "Enum",
    None = "None"
}
